import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/services/auth/auth.service';
import { MessagePopupComponent } from '../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../core/../core/services/popup/popup.service';

@Injectable({
	providedIn: 'root'
})

export class AdministrationService {

	private url = environment.do_services_sb_url;
	private getExistingUrl = 'userDetails/getAllUsers';
	private deleteUsersUrl = 'gigya/deleteUsers';
	private changeUserSubscription = 'userDetails/updateSubscriptionStatus';
	private usageLimitUrl = 'vinrate/get-usage-limit';
	private globalRateLimitUrl = 'vinrate/global-limit-rate';
	private userRegisterUrl = 'gigya/gigyaSecondaryRegistration';
	private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	constructor(private http: HttpClient, private authService: AuthService,
				private popupService: PopupService, private route: Router) { }

	getExistingUsers(userData: string): Observable<any> {
		return this.http.post(this.url + this.getExistingUrl, userData, { responseType: 'text' })
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getVinRateLimit(userMail: any): Observable<any> {
		let options = {
			headers: this.headers
		}
		return this.http.post(this.url + this.globalRateLimitUrl, userMail, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getUsageRate(userMail: any): Observable<any> {
		let options = {
			headers: this.headers
		}
		return this.http.post(this.url + this.usageLimitUrl, userMail, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	deleteExistingUsers(deleteUserList: string): Observable<any> {
		let options = {
			headers: this.headers
		}
		return this.http.post(this.url + this.deleteUsersUrl, deleteUserList, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	updateSubscriptionStatus(userdetails: any): Observable<any> {
		const options = {
			headers: this.headers
		}
		return this.http.post(this.url + this.changeUserSubscription, userdetails, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	registerSecondaryUser(registerUserInfo: string) {
		const options = {
			headers: this.headers
		}
		return this.http.post(this.url + this.userRegisterUrl, registerUserInfo, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}


	private handleError(error: any): Observable<never> {
        if([400, 403, 404, 405, 500, 502, 503, 504].includes(error.status)) {
            return throwError(() => error);
        }
        if(error.status === 401) {
			const dialogRef = this.popupService.openDialog(MessagePopupComponent, {
				data: { message: 'Unauthorized Request - Your Session has expired' }
			});
			dialogRef.afterClosed().subscribe(() => {
				this.authService.logout().subscribe(() => {
					this.route.navigate(['/home']);
				});
			});
			return throwError(() => new Error('Unauthorized Request - Session expired'));
		}
        return throwError(() => new Error(`Unhandled status code: ${error.status}`));
    }

}